import * as B from '../../BountyDetailParts'

const AcceptableBountyCard = () => {
  return (
    <B.StatusCard>
      <B.StatusHeading>Accepted</B.StatusHeading>
      <B.StatusParagraph>
        Post your video and tap link my video after you're done!
      </B.StatusParagraph>
    </B.StatusCard>
  )
}

export const BountyDetailAccepted = ({
  data,
  ...props
}: Omit<B.PageProps, 'children'>) => {
  return (
    <B.Page data={data} {...props}>
      <B.SparkCodes />
      <B.SectionGroup>
        <B.TitleRow />
        {data.bounty.isExpired ? <B.ExpiredCard /> : <AcceptableBountyCard />}
        <B.SearchingForVideoPreview />
        {data.bounty.canPostToOtherSocials && <B.CrossPostToOtherSocials />}
        {/* <YStack mt="$4">
          <B.RulesVideoCard />
        </YStack> */}
      </B.SectionGroup>
      <B.BriefsCard />
      <B.Guidelines />
      <B.CommunityRules />
      <B.CommunityRulesSheet />
    </B.Page>
  )
}
